import { render, staticRenderFns } from "./OrganizeTab.vue?vue&type=template&id=b004170c&"
import script from "./OrganizeTab.vue?vue&type=script&lang=js&"
export * from "./OrganizeTab.vue?vue&type=script&lang=js&"
import style0 from "./OrganizeTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports